module.exports = __webpack_public_path__ + "static/media/senha.57ef81a7.svg";